import { render } from "./ProductoServicioList.vue?vue&type=template&id=f195f3f8&scoped=true"
import script from "./ProductoServicioList.vue?vue&type=script&lang=js"
export * from "./ProductoServicioList.vue?vue&type=script&lang=js"

import "./ProductoServicioList.vue?vue&type=style&index=0&id=f195f3f8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f195f3f8"]])

export default __exports__